"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = require("lodash");

var _mappingToNestedFields = _interopRequireDefault(require("./mappingToNestedFields"));

var _mappingToScalarFields = _interopRequireDefault(require("./mappingToScalarFields"));

var _createConnectionTypeDefs = _interopRequireDefault(require("./createConnectionTypeDefs"));

var _mappingToObjectTypes = _interopRequireDefault(require("./mappingToObjectTypes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var mappingToNestedTypes = function mappingToNestedTypes(type, mapping, parent, extendedFields) {
  return Object.entries(mapping).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        metadata = _ref2[1];

    return metadata.type === 'nested';
  }).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        field = _ref4[0],
        metadata = _ref4[1];

    return "\n        ".concat((0, _mappingToObjectTypes["default"])(type + (0, _lodash.capitalize)(field), metadata.properties, [parent, field].filter(Boolean).join('.'), extendedFields), ",\n         ").concat(mappingToNestedTypes(type + (0, _lodash.capitalize)(field), metadata.properties, [parent, field].filter(Boolean).join('.'), extendedFields).join('\n'), "\n        ").concat((0, _createConnectionTypeDefs["default"])({
      type: _objectSpread(_objectSpread({}, type), {}, {
        name: type + (0, _lodash.capitalize)(field),
        mapping: metadata.properties
      }),
      fields: [(0, _mappingToScalarFields["default"])(metadata.properties, extendedFields, [parent, field].filter(Boolean).join('.')), (0, _mappingToNestedFields["default"])(type + (0, _lodash.capitalize)(field), metadata.properties, [parent, field].filter(Boolean).join('.'), extendedFields)]
    }), "\n      ");
  });
};

var _default = mappingToNestedTypes;
exports["default"] = _default;